import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { withShowToggle } from "src/components/hoc/withShowToggle";
import { DataProviderContext } from "src/core/provider/dataProvider";
import { getFabricRoute } from "src/utils/routesUtils";

import { usePreviewChangesDrawer } from "../usePreviewChangesDrawer";

import { ActionsToolbar } from "./ActionsToolbar";
import { PreviewChanges } from "./PreviewChanges";
import { ButtonProps } from "./types";

const FabricPreviewChanges = withShowToggle(({ handleAction }: ButtonProps) => {
  const { events } = useContext(DataProviderContext);
  return (
    <PreviewChanges handleAction={handleAction} count={events?.length ?? 0} />
  );
});

/**
 * Fabric-specific candidate actions component (backward compatibility wrapper)
 */
export const FabricCandidateActions = () => {
  const { previewChangesDrawer, openPreviewChangesDrawer } =
    usePreviewChangesDrawer();
  const { setMode, mode, fabric } = useContext(DataProviderContext);

  const redirect = useNavigate();

  const reviewConfiguration = useCallback(() => {
    if (fabric) {
      redirect(getFabricRoute(fabric.id, "candidate"));
    }
  }, [redirect, fabric]);

  return (
    <ActionsToolbar
      mode={mode}
      PreviewButton={FabricPreviewChanges}
      setMode={setMode}
      onPreviewChanges={openPreviewChangesDrawer}
      onReviewConfiguration={reviewConfiguration}
      previewChangesDrawer={previewChangesDrawer}
    />
  );
};
